import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

const PreviewProductModal = ({
  isPreviewModalOpen,
  togglePreviewModal,
  selectedProduct,
}) => {
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const [subcategoryAttributes, setSubcategoryAttributes] = useState([]);
  const [categoryAttributeValues, setCategoryAttributeValues] = useState({});
  const [subcategoryAttributeValues, setSubcategoryAttributeValues] = useState({});
  const [categoryAttributeLabels, setCategoryAttributeLabels] = useState({});
  const [subcategoryAttributeLabels, setSubcategoryAttributeLabels] = useState({});

  useEffect(() => {
    if (selectedProduct) {
      fetchCategoryAttributes(selectedProduct.category_id);
      fetchSubcategoryAttributes(selectedProduct.subcategory_id);
      fetchCategoryAttributeValues(selectedProduct.id);
      fetchSubcategoryAttributeValues(selectedProduct.id);
    }
  }, [selectedProduct]);

  const fetchCategoryAttributes = async (categoryId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/category-attributes/getByCategoryId/${categoryId}`
      );
      if (response.status === 200) {
        setCategoryAttributes(response.data);
        const labels = {};
        response.data.forEach((attr) => {
          labels[attr.id] = attr.name;
        });
        setCategoryAttributeLabels(labels);
      } else {
        console.error("Failed to fetch category attributes");
      }
    } catch (error) {
      console.error("Error fetching category attributes:", error);
    }
  };

  const fetchSubcategoryAttributes = async (subcategoryId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/subcategory-attributes/getBySubcategoryId/${subcategoryId}`
      );
      if (response.status === 200) {
        setSubcategoryAttributes(response.data);
        const labels = {};
        response.data.forEach((attr) => {
          labels[attr.id] = attr.name;
        });
        setSubcategoryAttributeLabels(labels);
      } else {
        console.error("Failed to fetch subcategory attributes");
      }
    } catch (error) {
      console.error("Error fetching subcategory attributes:", error);
    }
  };

  const fetchCategoryAttributeValues = async (productId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product-category-attribute-values/getByProduct/${productId}`
      );
      if (response.status === 200) {
        const values = {};
        response.data.forEach((attr) => {
          values[attr.attribute_id] = attr.value;
        });
        setCategoryAttributeValues(values);
      } else {
        console.error("Failed to fetch category attribute values");
      }
    } catch (error) {
      console.error("Error fetching category attribute values:", error);
    }
  };

  const fetchSubcategoryAttributeValues = async (productId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product-subcategory-attribute-values/getByProduct/${productId}`
      );
      if (response.status === 200) {
        const values = {};
        response.data.forEach((attr) => {
          values[attr.attribute_id] = attr.value;
        });
        setSubcategoryAttributeValues(values);
      } else {
        console.error("Failed to fetch subcategory attribute values");
      }
    } catch (error) {
      console.error("Error fetching subcategory attribute values:", error);
    }
  };

  console.log(selectedProduct);
  return (
    <>
      {isPreviewModalOpen && selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
          <div className="relative w-full max-w-2xl p-6 max-h-full">
            <div className="relative p-6 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-8">
              <div className="flex justify-between items-center pb-4 mb-4 border-b dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Preview Product
                </h3>
                <button
                  type="button"
                  onClick={togglePreviewModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="col-span-2">
                  <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                    Images
                  </h4>
                  <div className="flex space-x-2 overflow-x-auto">
                    {selectedProduct.imageURIs?.map((uri, index) => (
                      <img
                        key={index}
                        src={uri}
                        alt={`Product image ${index + 1}`}
                        className="w-24 h-24 object-cover rounded-lg shadow-md"
                      />
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Name
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.name}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Details
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.details}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Category
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.Category?.name}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Subcategory
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.Subcategory?.name}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Discount
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.discount}%
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Original Price
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    ${selectedProduct.price}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Final Price
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    ${selectedProduct.final_price}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                   Stock
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {selectedProduct.stock}
                  </p>
                </div>

                {categoryAttributes.map((attribute) => {
                  const existingValue =
                    categoryAttributeValues[attribute.attribute_id] || "";

                  return (
                    <div key={attribute.attribute_id}>
                      <label
                        htmlFor={`category-attribute-${attribute.attribute_id}`}
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {attribute.name}
                      </label>
                      <p className="text-gray-700 dark:text-gray-300">
                        {existingValue}
                      </p>
                    </div>
                  );
                })}

                {subcategoryAttributes.map((attribute) => {
                  const existingValue =
                    subcategoryAttributeValues[attribute.attribute_id] || "";

                  return (
                    <div key={attribute.attribute_id}>
                      <label
                        htmlFor={`subcategory-attribute-${attribute.attribute_id}`}
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {attribute.name}
                      </label>
                      <p className="text-gray-700 dark:text-gray-300">
                        {existingValue}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewProductModal;
